/* eslint-disable react/prop-types */
import '../HouseMoney/index.scss';
import { useEffect, useState } from 'react';
import { ModalProps } from '../../../types';
import ModalBase from '..';
import ModalExecuteAction from '../ModalExecuteAction';
import { getCurrentDayYear, months } from '../../../helpers/utils/date';
import useFlexDollar from '../../../hooks/useFlexDollar';

// Flex Dollar "Fix Interest": pick a month + year, confirm with the admin password, then
// POST admin/flexdollar/quick-actions { action: 'fix_interest', period: 'MM-YYYY' } (same period
// format HouseMoney sends; the worker validates /^\d{1,2}-\d{4}$/).
// Modelled on Modals/HouseMoney/ModalFixInterest, but keeps the selection local instead of in redux.
function ModalFlexDollarFixInterest({ modalIsOpen, setIsOpen, text, allowRender }: ModalProps) {
  if (allowRender === false) return null;
  const [showExecuteAction, setShowExecuteAction] = useState(false);
  const { runFlexDollarQuickAction, isRunningQuickAction } = useFlexDollar();

  const today = getCurrentDayYear();
  const [fixInterestYear, setFixInterestYear] = useState(today.year);
  const [fixInterestMonth, setFixInterestMonth] = useState<number>(-1);

  useEffect(() => {
    if (modalIsOpen) {
      setFixInterestYear(today.year);
      setFixInterestMonth(-1);
    }
  }, [modalIsOpen]);

  function closeModal() {
    setIsOpen(false);
    setShowExecuteAction(false);
  }

  const period = fixInterestMonth >= 0 ? `${String(fixInterestMonth + 1).padStart(2, '0')}-${fixInterestYear}` : '';

  const actionExecuter = (password?: string) => {
    if (!period) return;
    runFlexDollarQuickAction('fix_interest', { period }, password ?? '', closeModal);
  };

  const onButtonClick = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    if (!period) return;
    setIsOpen(false);
    setShowExecuteAction(true);
  };

  return (
    <>
      <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
        <div className={`modal-base general success action flex--4`}>
          <span onClick={closeModal}>&times;</span>

          <div className="change-rent-date change-rent-date--alt">
            <h1 className="heading">Fix Interest</h1>
            <p>Select Month and Year</p>
            <div className="date-picker">
              <div className="year-display flex--2">
                <p>{fixInterestYear}</p>
                <div className="year-changee">
                  <div onClick={() => setFixInterestYear((year: number) => year + 1)} className="pointer">
                    <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.95152 0.708496L0 4.59431H7.90304L3.95152 0.708496Z" fill="#9CA3AF" />
                    </svg>
                  </div>

                  <div onClick={() => setFixInterestYear((year: number) => year - 1)} className="pointer">
                    <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.95152 4.29524L7.90304 0.409424H0L3.95152 4.29524Z" fill="#9CA3AF" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="month-select">
                {months.map((month: string, index: number) => (
                  <p
                    key={`${index}-${month}`}
                    onClick={() => setFixInterestMonth(index)}
                    className={fixInterestMonth === index ? 'active' : ''}
                  >
                    {month}
                  </p>
                ))}
              </div>
            </div>
            <div className="button-container">
              <button
                disabled={!period}
                onClick={onButtonClick}
                style={period ? { backgroundColor: '#060f21' } : undefined}
              >
                {period ? `Apply ${months[fixInterestMonth]} ${fixInterestYear}` : 'Select a month'}
              </button>
            </div>
          </div>
        </div>
      </ModalBase>

      <ModalExecuteAction
        modalIsOpen={showExecuteAction}
        setIsOpen={setShowExecuteAction}
        text={text || `fix Flex Dollar interest for ${months[fixInterestMonth] ?? ''} ${fixInterestYear}`}
        actionColor="#060f21"
        action={(password: string) => actionExecuter(password)}
        isLoading={isRunningQuickAction}
      />
    </>
  );
}

export default ModalFlexDollarFixInterest;
